package org.zest.insan_360_website.utils

import kotlin.js.Date

import kotlinx.datetime.Instant
import org.zest.insan_360_website.data.Language
import org.zest.insan_360_website.data.page_states.UserPreferences

fun formatToReadableDateJS(instant: Instant): String {
    val date = Date(instant.toEpochMilliseconds().toDouble())
    val locale = if (UserPreferences.language == Language.BM) "ms-MY" else "en-US"

    return date.toLocaleString(
        locale,
        dateLocaleOptions {
            day = "numeric"
            month = "short"
            year = "numeric"
            hour = "numeric"
            minute = "2-digit"
        }
    )
}

fun convertToIsoDate(dateStr: String?, isEnd: Boolean = false): String? {
    if (dateStr.isNullOrBlank()) return null
    val parts = dateStr.split("-")
    if (parts.size != 3) return dateStr
    val year = parts[0].toIntOrNull() ?: return dateStr
    val month = (parts[1].toIntOrNull() ?: return dateStr) - 1
    val day = parts[2].toIntOrNull() ?: return dateStr
    
    val date = if (isEnd) {
        Date(year, month, day, 23, 59, 59, 999)
    } else {
        Date(year, month, day, 0, 0, 0, 0)
    }
    return date.toISOString()
}

fun getTodayDateString(): String {
    val date = Date()
    val yyyy = date.getFullYear()
    val mm = (date.getMonth() + 1).toString().padStart(2, '0')
    val dd = date.getDate().toString().padStart(2, '0')
    return "$yyyy-$mm-$dd"
}

fun getPastDateString(daysAgo: Int): String {
    val msPerDay = 24.0 * 60.0 * 60.0 * 1000.0
    val date = Date(Date.now() - daysAgo * msPerDay)
    val yyyy = date.getFullYear()
    val mm = (date.getMonth() + 1).toString().padStart(2, '0')
    val dd = date.getDate().toString().padStart(2, '0')
    return "$yyyy-$mm-$dd"
}